<div class="generic-dialog" [ngClass]="'generic-dialog--' + (data.type || 'info')">
  <div class="generic-dialog__header">
    <div class="generic-dialog__title">
      <span class="generic-dialog__icon-shell">
        <mat-icon class="generic-dialog__icon">{{ getIcon(data.type) }}</mat-icon>
      </span>
      <h3>{{ title }}</h3>
    </div>
    <button type="button" class="generic-dialog__close" aria-label="Close" (click)="onButtonClick('close')">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="generic-dialog__content">
    <div class="generic-dialog__message">
      <ng-container *ngFor="let line of messageLines; let i = index">
        <div class="generic-dialog__message-line" [class.generic-dialog__message-line--spaced]="i > 0">{{ line }}</div>
      </ng-container>
    </div>

    <div *ngIf="data.showNotesInput" class="generic-dialog__notes-wrap">
    <mat-form-field class="generic-dialog__notes" appearance="fill">
      <mat-label>Notes (optional)</mat-label>
      <textarea matInput
                [(ngModel)]="notes"
                [attr.maxlength]="notesMaxLength"
                rows="2"></textarea>
      <mat-hint align="end">You have {{ notes.length }} of {{ notesMaxLength }} characters remaining. </mat-hint>
    </mat-form-field>
    </div>

    <div *ngIf="data.requireConfirmCheckbox" class="confirm-checkbox">
      <mat-checkbox [(ngModel)]="isConfirmChecked">
        {{ data.confirmCheckboxLabel }}
      </mat-checkbox>
    </div>
  </div>

  <div class="generic-dialog__footer">
    <ng-container *ngFor="let btn of data.buttons">
      <button mat-button
              [color]="btn.color || null"
              [disabled]="btn.disabled || (btn.action === 'confirm' && data.requireConfirmCheckbox && !isConfirmChecked)"
              (click)="onButtonClick(btn.action)"
              [ngClass]="{
                'generic-dialog__btn': true,
                'generic-dialog__btn--cancel': btn.action === 'cancel',
                'generic-dialog__btn--action': btn.action === 'confirm'
              }"
      >
        {{ btn.text }}
      </button>
    </ng-container>
  </div>
</div>
